import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { ProfessionDataObject } from 'models/service';

export const getProfessions = async () =>
  apiClient.get<ProfessionDataObject[], ApiClientResponse<ProfessionDataObject[]>>(routes.user.professions);
